import React, { memo, useCallback } from 'react'
import ClassNames from 'classnames'
import { InputTextareaStyle } from './styled'
import { red } from '@material-ui/core/colors'

export const InputTextarea = memo(props => {
  const {
    className,
    label,
    type,
    id,
    name,
    placeholder,
    isHorizontal,
    isDisable,
    disabled,
    isDisabled,
    value,
    defaultValue,
    readOnly,
    isReadOnly,
    onChange,
    style,
    onBlur,
  } = props
  const renderTextarea = useCallback(() => {
    return (
      <InputTextareaStyle
        className={ClassNames(
          'input-textarea-control',
          { 'is-horizontal': isHorizontal },
          { 'is-disabled': isDisable || disabled || isDisabled },
          { 'is-read-only': readOnly || isReadOnly },
          className
        )}
      >
        {label && (
          <label className="label" htmlFor={id}>
            {label}
          </label>
        )}
        <textarea
          className="textarea"
          type={type}
          id={id}
          name={name}
          placeholder={placeholder}
          onChange={onChange}
          disabled={isDisable || disabled || isDisabled}
          readOnly={readOnly || isReadOnly}
          value={value}
          defaultValue={defaultValue}
          style={!style ? {} : { borderColor: 'red' }}
          onBlur={onBlur}
        />
      </InputTextareaStyle>
    )
  }, [
    className,
    label,
    type,
    id,
    name,
    placeholder,
    isHorizontal,
    isDisable,
    disabled,
    isDisabled,
    value,
    defaultValue,
    readOnly,
    isReadOnly,
    onChange,
    style,
  ])
  return renderTextarea()
})
